export default [{
  path: '/remover-georreferenciado',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Removedor de Registro Georreferenciado Histórico',
      path: 'historico',
      component: () => import('@/views/removedorGeorreferenciado/Historico.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Remover Georreferenciado' }
        ]
      }
    },
    {
      name: 'Removedor de Registro Georreferenciado Adicionar',
      path: 'adicionar',
      component: () => import('@/views/removedorGeorreferenciado/Add.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Remover Georreferenciado', path: '/remover-georreferenciado/historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]